import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useSupplyCase, SupplyCase } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<SupplyCase>
    useData={useSupplyCase}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
